export const newYorkMidnight = (asString = false) => {
	const tz = 'America/New_York';
	const now = new Date();

	// Get current time in New York
	const nyString = now.toLocaleString('en-US', { timeZone: tz });
	const nyNow = new Date(nyString);

	// Get today's date parts in New York
	const options = { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' };
	const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(now).reduce((acc, p) => {
		if (p.type === 'year') acc.year = p.value;
		if (p.type === 'month') acc.month = p.value;
		if (p.type === 'day') acc.day = p.value;
		return acc;
	}, {});

	// Create a date representing midnight in New York today
	let target = new Date(`${parts.year}-${parts.month}-${parts.day}T00:00:00`);

	// If New York time has already passed midnight for "today", bump to tomorrow
	if (nyNow.getDate() !== new Date(target.toLocaleString('en-US', { timeZone: tz })).getDate()) {
		target.setDate(target.getDate() + 1);
	}

	// If string requested, extract YYYY-MM-DD *from the adjusted target*
	if (asString) {
		const y = target.getFullYear();
		const m = String(target.getMonth() + 1).padStart(2, '0');
		const d = String(target.getDate()).padStart(2, '0');
		return `${y}-${m}-${d}`;
	}

	return target;
};

export const getContrastColor = (hexColor) => {
	if (!hexColor) return '#ffffff';
	const cleanHex = hexColor.replace('#', '');
	if (cleanHex.length !== 6 && cleanHex.length !== 3) return '#ffffff';

	let r, g, b;
	if (cleanHex.length === 3) {
		r = parseInt(cleanHex[0] + cleanHex[0], 16);
		g = parseInt(cleanHex[1] + cleanHex[1], 16);
		b = parseInt(cleanHex[2] + cleanHex[2], 16);
	} else {
		r = parseInt(cleanHex.substring(0, 2), 16);
		g = parseInt(cleanHex.substring(2, 4), 16);
		b = parseInt(cleanHex.substring(4, 6), 16);
	}

	const yiq = (r * 299 + g * 587 + b * 114) / 1000;
	return yiq >= 128 ? '#000000' : '#ffffff';
};

